// @ts-check
(function(){
  if (window.__addiPdpControllerLoaded) return;
  window.__addiPdpControllerLoaded = true;

  var observedPriceContainers = new WeakSet();
  var observedReferenceParents = new WeakSet();

  function getReferences(){
    return [].slice.call(document.querySelectorAll('.pdp-addi-widget-reference'));
  }

  function getSection(reference){
    return reference.closest('.shopify-section, dialog') || document;
  }

  function getPriceContainer(reference){
    var section = getSection(reference);
    return section.querySelector('[data-discount-price]');
  }

  function getPreferredAnchor(reference){
    var section = getSection(reference);
    return section.querySelector('.sg-modal__trigger') || reference;
  }

  function getWidget(reference){
    var nextElement = reference.nextElementSibling;
    if(nextElement instanceof HTMLElement && nextElement.tagName.toLowerCase() === 'addi-product-widget'){
      return nextElement;
    }

    var section = getSection(reference);
    return section.querySelector('addi-product-widget');
  }

  function getEffectivePrice(reference){
    var priceContainer = getPriceContainer(reference);
    if(!(priceContainer instanceof HTMLElement)) return null;

    var currentPriceCents = parseInt(priceContainer.dataset.currentPriceCents || '0', 10);
    if(Number.isNaN(currentPriceCents) || currentPriceCents <= 0) return null;

    return Math.round(currentPriceCents / 100);
  }

  function placeWidget(reference, widget){
    if(!(reference instanceof HTMLElement) || !(widget instanceof HTMLElement)) return;

    var anchor = getPreferredAnchor(reference);
    if(!(anchor instanceof HTMLElement) || anchor.nextElementSibling === widget) return;

    anchor.insertAdjacentElement('afterend', widget);
  }

  function syncReference(reference){
    if(!(reference instanceof HTMLElement)) return;

    var widget = getWidget(reference);
    var effectivePrice = getEffectivePrice(reference);

    if(!(widget instanceof HTMLElement) || effectivePrice === null) return;

    placeWidget(reference, widget);

    var nextPrice = String(effectivePrice);
    if(widget.getAttribute('price') !== nextPrice){
      widget.setAttribute('price', nextPrice);
    }
  }

  function syncAll(){
    getReferences().forEach(syncReference);
  }

  function scheduleSync(delay){
    setTimeout(function(){
      initObservers();
      syncAll();
    }, delay || 0);
  }

  function initObservers(){
    if(typeof MutationObserver === 'undefined') return;

    getReferences().forEach(function(reference){
      var priceContainer = getPriceContainer(reference);
      if(priceContainer instanceof HTMLElement && !observedPriceContainers.has(priceContainer)){
        observedPriceContainers.add(priceContainer);
        new MutationObserver(function(){
          scheduleSync(0);
        }).observe(priceContainer, {
          attributes: true,
          attributeFilter: ['data-current-price-cents', 'data-variant-id'],
        });
      }

      var referenceParent = reference.parentElement;
      if(referenceParent instanceof HTMLElement && !observedReferenceParents.has(referenceParent)){
        observedReferenceParents.add(referenceParent);
        new MutationObserver(function(){
          scheduleSync(0);
        }).observe(referenceParent, {
          childList: true,
        });
      }
    });
  }

  function init(){
    initObservers();
    syncAll();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('variant-price-fetched', function(){
    scheduleSync(0);
  });

  window.addEventListener('change', function(){
    scheduleSync(500);
  });
})();